import { render, staticRenderFns } from "./DocumentTypesPage.vue?vue&type=template&id=369d0b90&scoped=true"
import script from "./DocumentTypesPage.vue?vue&type=script&lang=js"
export * from "./DocumentTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d0b90",
  null
  
)

export default component.exports